import { BLOCK_CLASSES as e } from "../../constants.js";
import { defineAttrs as t } from "../../utils/typed-attrs.js";
import { centerable as n } from "../decorators/centerable.js";
import { uploadable as r } from "../decorators/uploadable.js";
import "../decorators.js";
//#region src/specs/nodes/image-text-spec.ts
var i = {
	element: e.imageText,
	image: `${e.imageText}-image`,
	imageContainer: `${e.imageText}-image-container`,
	description: `${e.imageText}-description`,
	textContainer: `${e.imageText}-text-container`,
	title: `${e.imageText}-title`
}, a = n(r({
	inline: !1,
	attrs: t({
		type: { default: "imageText" },
		imageUrl: { default: "" },
		text: { default: "" },
		title: { default: "" }
	}),
	group: "block",
	parseDOM: [{
		tag: i.element,
		getAttrs(e) {
			let t = e.querySelector(`.${i.image}`), n = e.querySelector(`.${i.title}`), r = e.querySelector(`.${i.description}`);
			return {
				imageUrl: t.getAttribute("src"),
				title: n.textContent,
				text: r.textContent
			};
		}
	}],
	toDOM(e) {
		let { imageUrl: t, text: n, title: r } = e.attrs;
		return [
			"div",
			{
				class: i.element,
				"data-type": "imageText"
			},
			[
				"div",
				{ class: i.imageContainer },
				["img", {
					src: t,
					alt: n,
					class: i.image
				}]
			],
			[
				"div",
				{ class: i.textContainer },
				[
					"div",
					{ class: i.title },
					[
						"b",
						{},
						r
					]
				],
				[
					"div",
					{ class: i.description },
					n
				]
			]
		];
	}
}));
function o(t) {
	t.querySelectorAll(`.${e.imageText}`).forEach((e) => {
		e.remove();
	});
}
//#endregion
export { o as cleanImageTextFromElement, i as imageTextCssClasses, a as imageTextSpec };
